export default function useScrollListener() {
  const scrollY = ref(null)
  const handleScroll = () => {
    scrollY.value = window.scrollY
  }
  // add window event to Nuxt using beforeMount and beforeDestroy:
  // https://stackoverflow.com/a/57803711
  // could also use if (process.client) { ... }
  onBeforeMount(() => {
    window.addEventListener('scroll', handleScroll)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll)
  })

  return {
    scrollY,
    handleScroll,
  }
}
